import React from 'react';
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Form from '../layout/form.jsx'
import Loader from '../layout/loader.jsx'
import { toast } from 'react-toastify'
import API from '../../services/api.jsx'
import DB from '../../services/db.jsx';
import Helpers from '../../services/helpers.jsx';

class PlaylistEdit extends React.Component {
	constructor(props) {
		super(props)
		const user = DB.get('user');

		const fields = {
			name: { label: 'Name', type: 'text', required: true },
			type: {
				label: 'Playlist type',
				type: 'select',
				options: Helpers.getPlaylistTypeOptions()
			},
			tag: { label: 'Tag', type: 'text', required: false },
		};
		fields.affiliates = {
			label: "Assigned affiliate(s)",
			type: "select-multi",
			optionKey: 'affiliates',
			fullWidth: true,
			required: false,
			options: [],
			hidden: (Helpers.isSuperAdmin() || Helpers.checkPermissions('playlists:edit')
          ? false
          : true) || user.affiliates.length === 1,
		};

		this.state = {
			loading: true,
			breadcrumb: {title: 'Back to playlist', path: '/assets/playlists/' + props.match.params.playlistId},
			fields,
			entity: null
		}
		this.saveEntity = this.saveEntity.bind(this)
	}

	componentDidMount() {
		this.loadPlaylist();
		// this.loadAffiliateOptions();
	}

	loadPlaylist() {
		API.getPlaylist(this.props.match.params.playlistId).then(client => this.setState({ loading: false, entity: client }))
	}

	// loadAffiliateOptions() {
	// 	API.getAffiliates().then((entities) => {
	// 		const affiliates = entities?.data?.map((affiliate) => ({
	// 			key: affiliate.id,
	// 			label: affiliate.name,
	// 		}));
	// 		this.setState((prevState) => ({
	// 			fields: {
	// 				...prevState.fields,
	// 				affiliates: { ...prevState.fields.affiliates, options: affiliates },
	// 			},
	// 		}));
	// 	});
  // }

	saveEntity(fields) {
		if (!Helpers.checkPermissions("playlists:edit")) {
      toast.error("You do not have permission to save it");
      return;
    }

		this.setState({ loading: true })
		if(fields.assets)
			fields.assets = fields.assets.map(asset => asset.id)
		else
			fields.assets = []
		API.update('playlists', this.props.match.params.playlistId, fields).then(() => {
			toast.success('Playlist has been updated')
			this.props.history.push('/assets/playlists/' + this.props.match.params.playlistId)
		}).catch(() => {
			// toast.error('An unexpected error has occured, please try again')
			this.setState({ loading: false })
		})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'Edit playlist'} breadcrumb={this.state.breadcrumb} />
				<Content>
					<Form fields={this.state.fields} cancel={() => this.props.history.push('/assets/playlists/' + this.props.match.params.playlistId)} save={this.saveEntity} entity={this.state.entity} />
				</Content>
			</>
	}
}

export default PlaylistEdit;
